export default "__VITE_ASSET__BzRqj3Ou__"